module.exports = __webpack_public_path__ + "static/img/合约模块.7bef8ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/合约模块.png
// module id = TtmO
// module chunks = 1